import axios from "axios";
// import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth.js";

const request = axios.create({
  // 1.复用请求地址前缀
  // baseURL: "https://api.v3.ycymedu.com/api/",
  baseURL: "https://api.v3.ycymedu.com/api/",
  // baseURL: process.env.VUE_APP_BASE_API,
  // 2.设置请求头
  // headers: {
  //   "Content-Type": "application/json",
  // },
  // 3.设置请求超时时间
  // timeout: 5000,
  // 4.设置请求携带cookie
  // withCredentials: true,
  // 5.设置请求数据类型",
  // 设置请求超时时间
  timeout: 5000,
  // 公共请求头
  headers: {},
});

// 请求拦截器
request.interceptors.request.use(
  // 成功
  (config) => {
    // 进度条展示
    NProgress.start();
    // (设置)复用公共请求参数
    // config就是请求的配置对象
    // config.params.xxx = xxx
    // config.data.xxx = xxx
    // config.headers.xxx = xxx
    const token = getToken();
    // 有token就带上
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  // 失败
  (error) => {
    console.log("___1", error);
  }
);

// 响应拦截器
request.interceptors.response.use((response) => {
  // 进度条结束
  NProgress.done();
  if (response.data.code === 401) {
    //window.location.href = process.env.VUE_APP_SSO_URL;
  }
  if (response.data.code === 500) {
    //  window.location.href = process.env.VUE_APP_SSO_URL;
  }
  if (response.data.success) {
    return response.data;
  } else {
    // 如果success为false 业务出错,直接触发reject
    // 被catch分支捕获
    // Promise.reject() // 生成一个失败状态的Promise
    return response.data;
  }
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // console.log('请求拦截器', config)
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2Njg0IiwiaWF0IjoiMTczMTAzMzA1MCIsIm5iZiI6IjE3MzEwMzMwNTAiLCJleHAiOiIxNzMxNjM3ODUwIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9leHBpcmF0aW9uIjoiMDgvMDUvMjAyNyAwMjozMDo1MCIsImlzcyI6Ik5ld19Db2xsZWdlIiwiYXVkIjoid3IiLCJuYW1lIjoi5a2m6Zy4Njk1MyJ9.W5S0pK_1VlWqY7TaGTM-rVSvZUOW9lbML3wwO9MsnKk';
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default request;
